// extracted by mini-css-extract-plugin
export default {"pageWrapper":"OlympusSlots_pageWrapper__oR2hE"};